import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useStatus } from '../context/StatusContext';
import { pathToServiceId, isServiceEnabled } from '../api/status';

/**
 * ServiceGuard (FC-090): When the current path maps to a monitored service that is
 * disabled in status, redirects to /outage. Otherwise renders children.
 * Used on /cloud, /stockbot, /investor, /audit.
 */
interface ServiceGuardProps {
  children: React.ReactNode;
  path?: string;
}

const ServiceGuard: React.FC<ServiceGuardProps> = ({ children, path: pathProp }) => {
  const location = useLocation();
  const path = pathProp ?? location.pathname;
  const { services, loading, publicHubStatusEnabled } = useStatus();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center" aria-busy="true">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
      </div>
    );
  }

  const serviceId = pathToServiceId(path);
  if (publicHubStatusEnabled && serviceId && !isServiceEnabled(services, serviceId)) {
    return <Navigate to="/outage" replace />;
  }

  return <>{children}</>;
};

export default ServiceGuard;
